import React, { Component } from 'react';
import './CtHead.css';
import { ASSETS_FOLDER } from '../../../constants';

class CtHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popMenuEnabled: false,
      popMenuVisible: false,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    // init resize
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // -------------------------------------------------------
  // Resize
  // -------------------------------------------------------

  handleResize() {
    const winW = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    const menuEnbled = winW <= 840;
    if (this.state.popMenuEnabled !== menuEnbled) {
      if (!menuEnbled) {
        this.setState({
          popMenuEnabled: menuEnbled,
          popMenuVisible: false,
        });
      } else {
        this.setState({
          popMenuEnabled: menuEnbled,
        });
      }
    }
  }

  // -------------------------------------------------------
  // Menu switch
  // -------------------------------------------------------

  popMenuSwitch() {
    this.setState(prevState => ({
      popMenuVisible: !prevState.popMenuVisible,
    }));
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const bgPattern = `${ASSETS_FOLDER}img/ct/wrapper-copyright.png`;

    // styles
    const popBtnStyle = {
      display: this.state.popMenuEnabled ? 'block' : 'none',
    };

    const arrowStyle = {
      display: this.state.popMenuVisible ? 'block' : 'none',
    };

    const popMenuStyle = {
      display: this.state.popMenuEnabled ? 'block' : 'none',
      height: this.state.popMenuVisible ? 341 : 0,
      backgroundImage: `url(${bgPattern})`,
      backgroundRepeat: 'repeat',
      backgroundColor: '#3c3c3c',
      transition: 'height 0.3s',
      transitionTimingFunction: 'ease-in-out',
    };

    return (
      <div id="ct-menu">
        <div id="navigation">
          <div className="wrapper">
            <div id="logo">
              <a href="//www.ceskatelevize.cz/" title="Česká televize">
                <img
                  src={`${ASSETS_FOLDER}img/ct/logo-ceskatelevize.png`}
                  alt="Česká televize"
                  title="Česká televize"
                  className="logo-min"
                />
                <img
                  src={`${ASSETS_FOLDER}img/ct/logo-ceskatelevize-full.png`}
                  alt="Česká televize"
                  title="Česká televize"
                  className="logo-full"
                />
              </a>
            </div>
            <div className="navigation-menu">
              <ul className="inlineMenu">
                <li>
                  <a href="//www.ceskatelevize.cz/ct24/" title="Zpravodajství">
                    Zpravodajství
                  </a>
                </li>
                <li>
                  <a href="//www.ceskatelevize.cz/sport/" title="Sport">
                    Sport
                  </a>
                </li>
                <li>
                  <a href="//www.ceskatelevize.cz/ivysilani/" title="iVysílání">
                    iVysílání
                  </a>
                </li>
                <li>
                  <a
                    href="//www.ceskatelevize.cz/tv-program/"
                    title="TV program"
                  >
                    TV program
                  </a>
                </li>
                <li>
                  <a
                    href="//www.ceskatelevize.cz/porady/a-z/"
                    title="Pořady A-Z"
                  >
                    Pořady A–Z
                  </a>
                </li>
                <li>
                  <a href="//decko.ceskatelevize.cz/" title="Pro děti">
                    Pro&nbsp;děti
                  </a>
                </li>
                <li>
                  <a href="//www.ceskatelevize.cz/vse-o-ct/" title="Vše o ČT">
                    Vše o ČT
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <button
            className="pop-menu"
            style={popBtnStyle}
            onClick={() => this.popMenuSwitch()}
          >
            <img src={`${ASSETS_FOLDER}img/ct/ct-menu.png`} alt="Menu" />
          </button>
          <img
            className="navigation-phone-menu-arrow"
            style={arrowStyle}
            src={`${ASSETS_FOLDER}img/ct/navigation-phone-menu-arrow.png`}
            alt="Šipka"
          />
        </div>
        <div className="navigation-phone-menu" style={popMenuStyle}>
          <ul>
            <li>
              <a href="//www.ceskatelevize.cz/ct24/" title="Zpravodajství">
                Zpravodajství
              </a>
            </li>
            <li>
              <a href="//www.ceskatelevize.cz/sport/" title="Sport">
                Sport
              </a>
            </li>
            <li>
              <a href="//www.ceskatelevize.cz/ivysilani/" title="iVysílání">
                iVysílání
              </a>
            </li>
            <li>
              <a href="//www.ceskatelevize.cz/tv-program/" title="TV program">
                TV program
              </a>
            </li>
            <li>
              <a href="//www.ceskatelevize.cz/porady/a-z/" title="Pořady A-Z">
                Pořady A–Z
              </a>
            </li>
            <li>
              <a href="//decko.ceskatelevize.cz/" title="Pro děti">
                Pro&nbsp;děti
              </a>
            </li>
            <li>
              <a href="//www.ceskatelevize.cz/vse-o-ct/" title="Vše o ČT">
                Vše o ČT
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default CtHead;



// WEBPACK FOOTER //
// ./src/components/App/CtHead/CtHead.js